import { callAPI } from '../../../services/api.service';
import { IPageDataModel } from '../../../interfaces/book.interface';
import { NavigateFunction } from 'react-router-dom';
import { Toast } from '../../../components/Common/Toast';
import { HTTPStatusEnum } from '../../../interfaces/log.interface';

export const fetchBookDataService = async (
  bookIdAdmin: string | null,
  bookId: string,
  isShare: boolean,
  shareKey?: string | null,
  isQR?: boolean,
  navigateTo?: NavigateFunction,
) => {
  try {
    const bookID = bookIdAdmin || bookId || '';
    if (bookID) {
      const data = !isShare
        ? await callAPI(`api/books/${bookID}`)
        : await callAPI(`api/books/${bookID}/share`, null, 'GET', { share: shareKey, ...(isQR ? { qr: 'true' } : {}) });
      if (data.status >= 200 && data.status < 300) {
        const totalPages = data?.data?.pages ? Object.keys(data?.data?.pages).length * 2 + 1 : 0;
        return { data: data?.data, totalPages };
      } else {
        if (isShare) {
          if (data.status === HTTPStatusEnum.CONFLICT && data.requireConfirmation) {
            navigateTo && navigateTo(`/story/bookflip/${bookID}/confirmation`);
            return { data: null, totalPages: 0 };
          }
          navigateTo && navigateTo('/not-found');
        }
        return { data: null, totalPages: 0 };
      }
    } else {
      if (isShare) {
        navigateTo && navigateTo('/not-found');
      }
      return { data: null, totalPages: 0 };
    }
  } catch (error) {
    if (isShare) {
      navigateTo && navigateTo('/not-found');
    }
    return { data: null, totalPages: 0 };
  }
};

export const sortedPages = (pages: { [namePage: string]: IPageDataModel }) => {
  if (pages) {
    return Object.entries(pages).sort(([pageKey1], [pageKey2]) => {
      const match1 = pageKey1?.match(/\d+/);
      const match2 = pageKey2?.match(/\d+/);

      const pageNum1 = match1 ? parseInt(match1[0]) : 0;
      const pageNum2 = match2 ? parseInt(match2[0]) : 0;

      return pageNum1 - pageNum2;
    });
  } else {
    return [];
  }
};

export const sendShareLinkToEmail = async (bookId: string, emails: string[]) => {
  try {
    const data = await callAPI(`api/books/${bookId}/share/email`, { emails }, 'POST');
    if (data.status >= 200 && data.status < 300) {
      Toast('Email sent successfully', false);
    } else {
      Toast('Something went wrong! Please try again...', true);
    }
  } catch (error) {
    Toast('Something went wrong', true);
  }
};

export const sendEmailBookAccess = async (
  bookId: string,
  email: string,
  shareKey?: string | null,
  onSuccess?: () => void,
) => {
  try {
    const data = await callAPI(`api/books/${bookId}/share/access`, { email: email }, 'POST', { share: shareKey });
    if (data.status >= 200 && data.status < 300) {
      Toast('Email sent successfully', false);
      onSuccess && onSuccess();
    } else {
      Toast('Something went wrong! Please try again...', true);
    }
  } catch (error) {
    Toast('Something went wrong', true);
  }
};

export const sendBookView = async (
  bookId: string,
  email: string | null,
  shareKey?: string | null,
  onSuccess?: () => void,
  onFailed?: (data: any) => void,
) => {
  try {
    const data = await callAPI(`api/books/${bookId}/share/view`, { email: email }, 'POST', { share: shareKey });
    if (data.status >= 200 && data.status < 300) {
      onSuccess && onSuccess();
    } else {
      onFailed && onFailed(data);
    }
  } catch (error) {}
};
